import styled from "styled-components";
import { COLORS, FONT_SIZE } from "../../constants/Styles";

export const BoardSummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: ${FONT_SIZE.size13};
  padding: 0.25rem;
`;

export const BoardSummaryDetail = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const InputLabel = styled.div`
  color: ${COLORS.secondaryLight};
`;
